import { Action, createReducer, on } from '@ngrx/store';
import { TASKS_PAGE_DEFAULT_SIZE } from 'src/app/conf/tasks';

import { ItemsPagination, StatusData } from 'src/app/model/api/data-rest';
import { PaginationParams } from 'src/app/model/api/pagination-params';
import { Task, TaskState, TaskType } from 'src/app/model/tasks';
import * as TasksActions from 'src/app/store/task/task.actions';


export interface State {
    errorMessage: string;
    tasks: Task[];
    activeTask: Task[];
    paginationParams: PaginationParams;
    itemsPagination?: ItemsPagination;
    tasksLoading: boolean;
    states: TaskState[];
    types: TaskType[];
    statusData?: StatusData;
}

export const initialState: State = {
    errorMessage: '',
    tasks: [],
    activeTask: [],
    tasksLoading: false,
    states: [],
    types: [],
    paginationParams: {
        size: TASKS_PAGE_DEFAULT_SIZE,
        page: 1,
        sort: 'updated_at',
        order: 'desc',
    },
};

const tasksReducer = createReducer(
    initialState,
    on(TasksActions.getTasks, (state) => ({ ...state, tasksLoading: true })),
    on(TasksActions.getTasksSuccess, (state, payload) => ({
        ...state,
        paginationParams: payload.paginationParams,
        itemsPagination: payload.paging,
        tasks: payload.tasks,
        tasksLoading: false
    })),
    on(TasksActions.getActiveTasksSuccess, (state, payload) => ({
        ...state,
        activeTask: payload.tasks,
    })),
    on(TasksActions.resetActiveTasks, (state) => {
        return { ...state, activeTask: [] };
    }),
    on(TasksActions.getTasksFailed, (state, payload) => ({ ...state, errorMessage: payload.errorMessage, tasksLoading: false })),
    on(TasksActions.getTaskStatesSuccess, (state, payload) => ({ ...state, states: payload.states })),
    on(TasksActions.getTaskStatesFailed, (state, payload) => ({ ...state, errorMessage: payload.errorMessage })),
    on(TasksActions.getTaskTypesSuccess, (state, payload) => ({ ...state, types: payload.types })),
    on(TasksActions.getTaskTypesFailed, (state, payload) => ({ ...state, errorMessage: payload.errorMessage })),
    on(TasksActions.getServiceStatusSuccess, (state, payload) => ({ ...state, statusData: payload.statusData })),
);

export const reducer = (state: State | undefined, action: Action): State => tasksReducer(state, action);
